import { FC, SyntheticEvent } from 'react';
import { Link } from 'react-router';
import classNames from 'classnames';
import { passAffiliateParams } from 'react-easyrocket';
import { useTranslation } from 'react-i18next';

interface SocialMediaLinkProps {
  name: string;
  path: string;
  onClick?: (e: SyntheticEvent) => void;
  isSmall: boolean;
  image?: string | null;
}

export const SocialMediaLink: FC<SocialMediaLinkProps> = ({
  image,
  name,
  path,
  onClick,
  isSmall
}) => {
  const {
    i18n: { language }
  } = useTranslation();
  const affiliateParams = passAffiliateParams();
  const firstChar = name[0];

  const url = new URL(path);

  const params = new URLSearchParams(url.search);

  params.append('lang', language);
  Object.entries(affiliateParams).forEach(([key, value]) => {
    params.append(key, value);
  });

  return (
    <Link
      onClick={(e) => onClick?.(e)}
      referrerPolicy="origin"
      to={`${url.origin.toString()}${url.pathname.toString()}?${params.toString()}`}
      className={classNames(
        'flex justify-center rounded-full py-1 items-center cursor-pointer border border-sml_border min-w-10 min-h-10 bg-sml_bg hover:bg-sml_bg_hover hover:border-sml_border_hover',
        isSmall ? 'w-fit' : 'w-full'
      )}>
      {image ? (
        <img
          alt="social icon"
          className={classNames('w-6 h-6', !isSmall && 'mr-2.5')}
          src={image}
        />
      ) : (
        isSmall && <span className="uppercase font-bold text-lm_create_account">{firstChar}</span>
      )}

      {!isSmall && <span className="text-base text-sml_text">{name}</span>}
    </Link>
  );
};
